import React from 'react';

export const ZeplinSearchResultIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.62389 23.9703L8.0544 24.5242L7.9704 29.0335L13.4029 27.1172C11.5394 26.5125 10.1789 25.4486 9.62389 23.9703Z"
			fill="#FDBD39"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.445 19.2006L5 21.1217L8.05498 24.5241L9.62397 23.9702C9.07047 22.4962 9.41147 20.8305 10.445 19.2006Z"
			fill="#F69833"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.6089 12.6933C12.6745 15.1399 8.20398 20.1887 9.62397 23.9702L34.7343 15.11C33.3143 11.3285 26.5429 10.2467 19.6089 12.6933Z"
			fill="#FECF33"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M24.7499 26.387C31.6838 23.9398 36.1623 18.9138 34.7348 15.11L9.62347 23.9703C11.0515 27.774 17.8154 28.8336 24.7499 26.387Z"
			fill="#EE6723"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M34.7348 15.11L9.62347 23.9703C10.115 25.28 11.9905 25.9253 14.6209 25.9253C17.1859 25.9253 20.4694 25.3124 23.8924 24.1045C30.8263 21.6579 35.7048 17.6962 34.7338 15.11"
			fill="#F69833"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M29.7368 13.155C27.1718 13.155 23.8883 13.7679 20.4654 14.9758C13.5314 17.4224 8.65295 21.3836 9.62394 23.9702L34.7343 15.11C34.2428 13.8003 32.3678 13.155 29.7368 13.155Z"
			fill="#FDBD39"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M28.3499 29.2725C27.6109 29.2725 26.5214 28.6278 25.1099 27.3567C23.4414 25.8528 21.5294 23.65 19.7264 21.1537C17.924 18.6583 16.4425 16.1628 15.5555 14.1277C14.5895 11.91 14.4515 10.5466 15.146 10.0748C15.2985 9.97141 15.482 9.91925 15.692 9.91925C16.257 9.91925 17.358 10.3254 19.3934 12.2616L19.4384 12.3036L19.4319 12.3639C19.4179 12.503 19.4054 12.6436 19.3939 12.7812L19.3714 13.0546L19.1714 12.8604C16.978 10.7258 16.0125 10.4954 15.699 10.4954C15.6095 10.4954 15.5385 10.5128 15.4875 10.5476C15.186 10.7519 15.1665 11.7535 16.1035 13.9031C16.975 15.902 18.4345 18.3593 20.2134 20.8228C21.9934 23.2869 23.8759 25.4572 25.5154 26.9341C27.2829 28.5269 28.0794 28.6988 28.3404 28.6988C28.4304 28.6988 28.5029 28.6805 28.5574 28.6433C28.8749 28.4279 28.8754 27.3548 27.8304 25.0404L27.7824 24.9347L27.8874 24.8791C27.9924 24.8236 28.0944 24.769 28.1894 24.7169L28.3154 24.6478L28.3734 24.7758C29.1139 26.4154 29.8064 28.4993 28.8984 29.1161C28.7454 29.2199 28.5609 29.2725 28.3499 29.2725Z"
			fill="#EE6723"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M24.9179 26.3179L24.9079 26.4434C24.7324 28.5389 24.2704 31.0575 23.0669 31.1599C23.0429 31.1619 23.0179 31.1628 22.9929 31.1628C22.1749 31.1628 21.4014 30.0313 20.6939 27.8C20.0239 25.6886 19.5039 22.8546 19.2304 19.8183C18.9564 16.7834 18.9604 13.9041 19.2419 11.712C19.5484 9.3228 20.1324 8.07534 20.9774 8.00338C21.0024 8.00145 21.0284 8 21.0539 8C21.6469 8 22.5409 8.64909 23.4559 11.6704L22.8584 11.7815C22.5529 10.7721 22.2199 9.95112 21.8894 9.38607C21.5834 8.86448 21.2864 8.57713 21.0524 8.57713C21.0444 8.57713 21.0369 8.57713 21.0289 8.57809C20.6629 8.609 20.1294 9.46721 19.8324 11.783C19.5559 13.936 19.5524 16.7718 19.8224 19.7681C20.0934 22.7648 20.6044 25.5572 21.2624 27.6305C21.5569 28.5587 21.8799 29.3242 22.1969 29.8434C22.4889 30.3225 22.7714 30.5862 22.9924 30.5862C22.9999 30.5862 23.0074 30.5862 23.0154 30.5852C23.3654 30.5557 24.0259 29.6628 24.3039 26.5212L24.9179 26.3179Z"
			fill="#EE6723"
		/>
	</svg>
);
